module.exports = __webpack_public_path__ + "img/img_covertack_round.22676796.png";